import { useEffect, useState } from "react";
import { getFacultyList } from "../service/facultyService";
import { FacultyListItem } from "../types";

export function useListFaculty() {
  const [faculties, setFaculties] = useState<FacultyListItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        setFaculties(await getFacultyList());
      } catch (e: any) {
        setError("Failed to load faculty.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return { faculties, loading, error };
}
